import React from "react";
import Table from "../../../components/molecules/Table";
import classNames from "classnames";
import { useMaliciousByIp } from "../api/apiHooks";

const MaliciousIpItemTable = ({ ip }) => {
  const {
    data: maliciousIpData,
    isFetching: isFetchingMaliciousIpData,
  } = useMaliciousByIp(ip);

  const cellContent = ({ text, className = "", onClick = null }) => (
    <div onClick={onClick} className={classNames("simple-field", className)}>
      <span>{text}</span>
    </div>
  );

  const colData = [
    {
      title: "Blocked at",
      dataIndex: "block_reason",
      render: (text) => cellContent({ text }),
    },
    {
      title: "Date",
      dataIndex: "blocked_at",
      render: (text) => cellContent({ text }),
    },
    {
      title: "Released at",
      dataIndex: "blocked_until",
      render: (text) => cellContent({ text: text || "Permanent" }),
    },
    {
      title: "Released type",
      dataIndex: "unblock_reason",
      render: (text) => cellContent({ text: text || "Permanent" }),
    },
  ];

  return (
    <Table
      className="table__malicious-ip-list table__malicious-ip-list-item"
      colData={colData}
      rowData={maliciousIpData?.history?.map((item, i) => ({
        key: i + 1,
        ...item,
      }))}
      loading={isFetchingMaliciousIpData}
    />
  );
};

export default MaliciousIpItemTable;
